
import { RentalItem } from './types';

export const POPULAR_ITEMS: RentalItem[] = [
  // Technische & Event Gear (Focus)
  { name: 'Pioneer DJ Set (CDJ-3000 & DJM-900NXS2)', category: 'Audio', description: 'De standaard voor elke professionele booth.' },
  { name: 'Moving Head LED (Set van 4)', category: 'Verlichting', description: 'Spectaculaire lichtshow voor elk event.' },
  { name: 'Rookmachine 1500W', category: 'Effecten', description: 'Maak lichtstralen zichtbaar met een dikke nevel.' },
  { name: 'Draadloze Microfoonset (Shure SM58)', category: 'Audio', description: 'Betrouwbare zang- en spraakversterking zonder kabels.' },
  { name: 'Aggregaat 5kVA', category: 'Stroom', description: 'Overal stroomvoorziening voor je buitenfeest.' },
  { name: 'Truss Systeem (4 meter)', category: 'Rigging', description: 'Stevige constructie voor verlichting en speakers.' },
  { name: 'LED Wall P3.9 (per m2)', category: 'Visueel', description: 'Indrukwekkende schermen voor presentaties en video.' },
  
  // Keuken & Catering Gear (Omdat hij echt alles heeft)
  { name: 'Oventje', category: 'Keuken', description: 'Een handig, compact oventje voor de snelle klus.' },
  { name: 'Rational Combi-Steamer iCombi Pro', category: 'Keuken', description: 'De ultieme oven voor high-end catering op locatie.' },
  { name: 'Mobiele Bar met Tapinstallatie', category: 'Catering', description: 'Snel en koud bier tappen op elk event.' },
  { name: 'La Marzocco Espressomachine 2-groups', category: 'Keuken', description: 'Barista-kwaliteit koffie voor je gasten.' }
];

export const GOOGLE_COLORS = {
  blue: '#4285F4',
  red: '#EA4335',
  yellow: '#FBBC05',
  green: '#34A853'
};
